import React, { useEffect, useState } from 'react';
import { AutoComplete } from 'material-ui';
import useDebounce from 'helpers/useDebounce';
import api from 'services';

/**
* @param {{
*  customValue?: string,
*  style?: React.CSSProperties,
*  popoverProps?: React.CSSProperties,
*  textFieldStyle?: React.CSSProperties,
*  underlineStyle?: React.CSSProperties,
*  floatingLabelStyle?: React.CSSProperties,
*  inputStyle?: React.CSSProperties,
*  menuStyle?: React.CSSProperties,
*  disabled?: boolean,
*  hintText?: string,
*  hintStyle?: React.CSSProperties,
*  onUserSelected: Function,
*  onUserChanging?: Function,
*  resetInput?: boolean,
*  withExtendedData?: boolean,
*  floatingLabelText?: string,
*  errorText?: string,
* }} param0 
*/

export default function UserAutoComplete({
    customValue = '',
    style = {},
    popoverProps = {},
    textFieldStyle = {},
    underlineStyle = {},
    floatingLabelStyle = {},
    inputStyle = {},
    menuStyle = {},
    hintStyle = {},
    disabled = false,
    hintText = '',
    onUserSelected = (val) => {},
    onUserChanging = (val) => {},
    resetInput = false,
    withExtendedData = false,
    floatingLabelText = '',
    errorText = '',
}) {
    const [userEmailValue, setUserEmailValue] = useState(customValue);
    const [user, setUser] = useState(null);
    const [users, setUsers] = useState([]);
    const [preventFirstSearch, setPreventFirstSearch] = useState(true);

    const debouncedSearchValue = useDebounce(userEmailValue, 500);

    useEffect(() => {
        setPreventFirstSearch(false);
    }, []);

    useEffect(() => {
        setUserEmailValue(customValue || '');
    }, [customValue]);

    const setCompanyValueFromOutside = () => {
        setUserEmailValue('');
    };

    useEffect(() => {
        if (resetInput) {
            setUserEmailValue('');
        }
    }, [resetInput]);
    
    const changeEmail = async (value) => {
        setUserEmailValue(value);
        setUser(null);
        if (onUserChanging) onUserChanging(value);
    };

    useEffect(() => {
        if (preventFirstSearch || !debouncedSearchValue || debouncedSearchValue.length < 3) {
            return;
        }

        api.findUser(debouncedSearchValue, withExtendedData)
            .then((res) => {
                setUsers(res.data.data.map(item => ({
                    user: item.email,
                    item,
                })));
            })
            .catch();
    }, [debouncedSearchValue]);

    const chooseEmail = (val) => {
        setUser(val);
        onUserSelected(val);
    };

    return (
        <AutoComplete
            name='userEmail'
            textFieldStyle={{ fontSize: '13px', ...textFieldStyle }}
            hintText={hintText || 'User email or id'}
            searchText={userEmailValue}
            dataSource={users || []}
            dataSourceConfig={{ text: 'user', value: 'item' }}
            onUpdateInput={changeEmail}
            onNewRequest={chooseEmail}
            filter={AutoComplete.noFilter}
            listStyle={{ overflow: 'auto', maxHeight: '300px' }}
            style={{ ...style }}
            underlineStyle={{ ...underlineStyle }}
            floatingLabelStyle={{ ...floatingLabelStyle }}
            floatingLabelText={floatingLabelText}
            inputStyle={{ ...inputStyle }}
            popoverProps={{
                canAutoPosition: true,
                style: {
                    width: '300px',
                },
                ...popoverProps,
            }}
            errorText={errorText}
            fullWidth
            disabled={disabled}
            hintStyle={{ ...hintStyle }}
            menuStyle={{ ...menuStyle }}
        />
    );
}



// WEBPACK FOOTER //
// ./app/components/common/UserAutoComplete.jsx